import {
  ApartmentOutlined,
  CalendarOutlined,
  HomeOutlined,
  MailOutlined,
  PhoneOutlined,
  TeamOutlined,
  UserOutlined,
} from "@ant-design/icons"
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Space,
  TreeSelect,
  Typography
} from "antd"
import dayjs from "dayjs"
import { useSelector } from "react-redux"
import notice from "src/components/Notice"
import { GUIDE_ONE, SYSTEM_KEY } from "src/constants/constants"
import { getRegexEmail, getRegexMobile } from "src/lib/stringsUtils"
import { getListComboByKey } from "src/lib/utils"
import AssociationService from "src/services/AssociationService"

const { Title } = Typography

const AssociationForm = ({
  treeData,
  setTreeData,
  loading = false,
  setLoading = () => {},
  onSuccess = () => {},
}) => {
  const { listSystemKey } = useSelector(state => state.appGlobal)
  const [form] = Form.useForm()

  const handleCreateAssoc = async () => {
    try {
      setLoading(true)
      const values = await form.validateFields()

      const res = await AssociationService.createAssociation({
        ...values,
        EstablishmentDate: values?.EstablishmentDate.format(),
        Status: 2,
        IsDelete: false,
      })

      if (res?.isError) return

      notice({
        msg: "Thêm hiệp hội thành công!",
      })
      form.resetFields()
      onSuccess()
    } finally {
      setLoading(false)
    }
  }

  const handleReset = () => {
    form.resetFields()
  }

  return (
    <div style={{ padding: "20px", minHeight: "500px" }}>
      <Form
        form={form}
        layout="vertical"
        size="middle"
        initialValues={{
          SortOrder: 0,
          Status: 2,
          AssociationType: 1,
          ParentId: GUIDE_ONE,
          EstablishmentDate: dayjs(),
        }}
      >
        <Row gutter={[20, 12]}>
          {/* Left Column */}
          <Col xs={24} lg={12}>
            <Row gutter={[16, 12]}>
              <Col span={24}>
                <Form.Item
                  label={
                    <span style={{ fontWeight: 600, fontSize: 14 }}>
                      <UserOutlined
                        style={{ marginRight: 6, color: "#01b39e" }}
                      />
                      Tên hiệp hội
                    </span>
                  }
                  name="Name"
                  rules={[
                    { required: true, message: "Vui lòng nhập tên hiệp hội" },
                  ]}
                  style={{ marginBottom: 16 }}
                >
                  <Input
                    placeholder="Nhập tên hiệp hội"
                    style={{ borderRadius: 6 }}
                    prefix={<UserOutlined style={{ color: "#bfbfbf" }} />}
                  />
                </Form.Item>
              </Col>

              <Col span={24}>
                <Form.Item
                  label={
                    <span style={{ fontWeight: 600, fontSize: 14 }}>
                      <ApartmentOutlined
                        style={{ marginRight: 6, color: "#01b39e" }}
                      />
                      Hội trực thuộc
                    </span>
                  }
                  name="ParentId"
                  rules={[
                    {
                      required: true,
                      message: "Vui lòng chọn hội trực thuộc",
                    },
                  ]}
                  style={{ marginBottom: 16 }}
                >
                  <TreeSelect
                    style={{ width: "100%" }}
                    placeholder="Chọn hội trực thuộc"
                    allowClear
                    treeDefaultExpandAll
                    treeData={treeData?.tree}
                    showSearch
                    treeNodeFilterProp="title"
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12}>
                <Form.Item
                  label={
                    <span style={{ fontWeight: 600, fontSize: 14 }}>
                      <MailOutlined
                        style={{ marginRight: 6, color: "#01b39e" }}
                      />
                      Email
                    </span>
                  }
                  name="Email"
                  rules={[
                    {
                      required: true,
                      pattern: getRegexEmail(),
                      message: "Email không hợp lệ",
                    },
                  ]}
                  style={{ marginBottom: 16 }}
                >
                  <Input
                    placeholder="Nhập email"
                    style={{ borderRadius: 6 }}
                    prefix={<MailOutlined style={{ color: "#bfbfbf" }} />}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12}>
                <Form.Item
                  label={
                    <span style={{ fontWeight: 600, fontSize: 14 }}>
                      <PhoneOutlined
                        style={{ marginRight: 6, color: "#01b39e" }}
                      />
                      Số điện thoại
                    </span>
                  }
                  name="PhoneNumber"
                  rules={[
                    {
                      required: true,
                      pattern: getRegexMobile(),
                      message: "Số điện thoại từ 10-11 chữ số",
                    },
                  ]}
                  style={{ marginBottom: 16 }}
                >
                  <Input
                    placeholder="Nhập số điện thoại"
                    style={{ borderRadius: 6 }}
                    prefix={<PhoneOutlined style={{ color: "#bfbfbf" }} />}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>

          {/* Right Column */}
          <Col xs={24} lg={12}>
            <Row gutter={[16, 12]}>
              <Col xs={24} sm={12}>
                <Form.Item
                  label={
                    <span style={{ fontWeight: 600, fontSize: 14 }}>
                      <CalendarOutlined
                        style={{ marginRight: 6, color: "#01b39e" }}
                      />
                      Ngày thành lập
                    </span>
                  }
                  name="EstablishmentDate"
                  rules={[{ required: true, message: "Vui lòng chọn ngày" }]}
                  style={{ marginBottom: 16 }}
                >
                  <DatePicker
                    style={{ width: "100%" }}
                    disabledDate={current => current && current > dayjs()}
                    placeholder="Chọn ngày"
                    format="DD/MM/YYYY"
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12}>
                <Form.Item
                  label={
                    <span style={{ fontWeight: 600, fontSize: 14 }}>
                      <TeamOutlined
                        style={{ marginRight: 6, color: "#01b39e" }}
                      />
                      Loại hiệp hội
                    </span>
                  }
                  name="AssociationType"
                  rules={[{ required: true, message: "Vui lòng chọn loại" }]}
                  style={{ marginBottom: 16 }}
                >
                  <Select placeholder="Chọn loại hiệp hội">
                    {getListComboByKey(
                      SYSTEM_KEY?.ASSOCIATION_TYPE,
                      listSystemKey,
                    )?.map(i => (
                      <Select.Option key={+i.CodeValue} value={+i.CodeValue}>
                        {i?.Description}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col span={24}>
                <Form.Item
                  label={
                    <span style={{ fontWeight: 600, fontSize: 14 }}>
                      <HomeOutlined
                        style={{ marginRight: 6, color: "#01b39e" }}
                      />
                      Địa chỉ
                    </span>
                  }
                  name="Address"
                  rules={[{ required: true, message: "Vui lòng nhập địa chỉ" }]}
                  style={{ marginBottom: 20 }}
                >
                  <Input.TextArea
                    placeholder="Nhập địa chỉ chi tiết"
                    rows={3}
                    style={{ borderRadius: 6, resize: "none" }}
                  />
                </Form.Item>
              </Col>

              <Col span={24}>
                <div style={{ textAlign: "right", paddingTop: 8 }}>
                  <Space>
                    <Button
                      onClick={handleReset}
                      loading={loading}
                      disabled={loading}
                      style={{
                        borderRadius: 6,
                        minWidth: 100,
                        height: 36,
                      }}
                    >
                      Đặt lại
                    </Button>
                    <Button
                      type="primary"
                      onClick={handleCreateAssoc}
                      loading={loading}
                      disabled={loading}
                      style={{
                        borderRadius: 6,
                        minWidth: 100,
                        height: 36,
                        background:
                          "linear-gradient(135deg, #01b39e 0%, #019085 100%)",
                        border: "none",
                        boxShadow: "0 2px 8px rgba(1, 179, 158, 0.3)",
                      }}
                    >
                      Tạo mới
                    </Button>
                  </Space>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>
    </div>
  )
}

export default AssociationForm
